import React from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

interface AppPageLayoutProps {
  children: React.ReactNode;
  /** Inner content max-width in px. Default 1000 (admin/list views). */
  maxWidth?: number;
  /** Outer content padding in px. Default 32. */
  padding?: number;
  /** Page background. Default '#f5f5f5'. */
  background?: string;
}

const AppPageLayout: React.FC<AppPageLayoutProps> = ({
  children,
  maxWidth = 1000,
  padding = 32,
  background = 'transparent',
}) => {
  return (
    // `minHeight: '100%'`, not `100vh`: this renders inside App.tsx's
    // scrollable content region (viewport height minus the footer), not the
    // raw viewport. `100vh` here would force every page to overflow by
    // exactly the footer's height, pushing it out of view.
    <Layout style={{ minHeight: '100%', background }}>
      <Content style={{ padding, maxWidth, margin: '0 auto', width: '100%' }}>
        {children}
      </Content>
    </Layout>
  );
};

export default AppPageLayout;
